var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 18C19.6668 18.9205 18.9206 19.6667 18.0002 19.6667C17.0797 19.6667 16.3335 18.9205 16.3335 18C16.3335 17.0795 17.0797 16.3333 18.0002 16.3333C18.9206 16.3333 19.6668 17.0795 19.6668 18Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 12.1667C19.6668 13.0871 18.9206 13.8333 18.0002 13.8333C17.0797 13.8333 16.3335 13.0871 16.3335 12.1667C16.3335 11.2462 17.0797 10.5 18.0002 10.5C18.9206 10.5 19.6668 11.2462 19.6668 12.1667Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 23.8333C19.6668 24.7538 18.9206 25.5 18.0002 25.5C17.0797 25.5 16.3335 24.7538 16.3335 23.8333C16.3335 22.9129 17.0797 22.1667 18.0002 22.1667C18.9206 22.1667 19.6668 22.9129 19.6668 23.8333Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalicon);
export default __webpack_public_path__ + "static/media/verticalicon.efae104374dc357ae8e4f81896c93bc3.svg";
export { ForwardRef as ReactComponent };